import type { BossDef } from '@nebulark/engine';

export const BOSS_STAGE1: BossDef = {
  id: 'boss-stage1',
  hp: 200,
  radius: 48,
  phases: [
    { hpThreshold: 1.0, pattern: 'fan',         fireRateHz: 0.8, bulletSpeed: 220 },
    { hpThreshold: 0.66, pattern: 'aimed-burst', fireRateHz: 1.2, bulletSpeed: 280 },
    { hpThreshold: 0.33, pattern: 'spiral',      fireRateHz: 2.0, bulletSpeed: 260 },
  ],
};
